/* eslint-disable no-console */
import React from 'react'
import { Box } from '@mui/material'
import LoadMoreButton from 'components/LoadMoreButton'
import { SimpleLoading } from 'components/LoadingIcon'
import { styles } from '../styles'
import EventGroup from './event-group'
import NoEvents from './no-events'
import type { EventTabProps } from './types'
import useEvents from './use-events'

const EventTab: React.FC<EventTabProps> = (props) => {
  const { loading, groupedEvents, hasMoreElements, loadMore } = useEvents(props)

  if (!loading && groupedEvents.length === 0) {
    return <NoEvents />
  }

  return (
    <>
      <Box sx={styles.cardContainer}>
        {groupedEvents.map((group) => (
          <EventGroup key={group.dateLabel} dateLabel={group.dateLabel} contents={group.contents} />
        ))}
      </Box>
      {loading && <SimpleLoading />}
      {!loading && hasMoreElements && <LoadMoreButton onClick={loadMore} />}
    </>
  )
}

export default EventTab
